<template>
    <ReviewList v-if="reviews().hasReviews" />
</template>

<script setup async lang="ts">
    import ReviewList from '~/components/Review/ReviewList.vue'
    import { reviews } from '~/store/reviews'
    const route = useRoute()
    await reviews().fetchReviewStats()
    await reviews().fetchCustomerReviews(10, Number(route?.params?.page) || 1)
</script>
